export default __webpack_public_path__ + "static/media/stacey.7963714f.jpg";